import { defineStore } from "pinia";
import GlobalService from "@/services/global-service";
import { ChatwootService } from "@/services/chatwoot-service";

type State = {
  ready: boolean;
};

export const useChatwootStore = defineStore("chatwoot", {
  state: (): State => ({
    ready: false
  }),
  actions: {
    async init(): Promise<void> {
      const locale = GlobalService.translator().getLocale?.() ?? "en";
      await ChatwootService.ensureLoaded(locale);
      this.ready = true;
    },

    async open(): Promise<void> {
      this.ready ? ChatwootService.open() : await this.init().then(() => ChatwootService.open());
    },

    close(): void {
      ChatwootService.close();
    }
  }
});
